import React from 'react';
import clsx from 'clsx';
import styles from './radio-button.module.scss';

interface RadioButtonProps {
  id: string;
  name: string;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string | React.ReactNode;
  className?: string;
  position?: 'left' | 'right';
  dataCy?: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  id,
  name,
  value,
  checked,
  onChange,
  label,
  className,
  position = 'left',
  dataCy,
}) => {
  return (
    <div
      className={clsx(styles.radioButtonContainer, className)}
      data-cy={dataCy}
    >
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        className={clsx(
          position === 'left' && styles['vc-radio__input'],
          position === 'right' ? 'vc-form-radioInput' : 'vc-radio__input',
        )}
        checked={checked}
        onChange={onChange}
      />
      <label
        htmlFor={id}
        className={clsx(
          position === 'left' && styles['vc-radio__label'],
          position === 'right' ? 'vc-form-radioLabel' : 'vc-radio__label',
        )}
      >
        {position === 'right' ? (
          <>
            <span>{label}</span>
            <span className="vc-form-radioLabel__btn"></span>
          </>
        ) : (
          <span>{label}</span>
        )}
      </label>
    </div>
  );
};

export default RadioButton;
